import { render, staticRenderFns } from "./Poimap.vue?vue&type=template&id=0c8d810c&scoped=true&"
import script from "./Poimap.vue?vue&type=script&lang=js&"
export * from "./Poimap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d810c",
  null
  
)

export default component.exports